import type { ProductLineItem } from '@weft/services';
import { isLineItemWithUnits, isCommitmentLineItem } from '@weft/services';
import { sumBy, values } from '@weft/utils';
import { useMemo } from 'react';

export function useCommitmentUnits(productLineItem: ProductLineItem) {
  const isNotFixedLineItem = isLineItemWithUnits(productLineItem);
  const hasCommitment = isCommitmentLineItem(productLineItem);
  
  return useMemo(() => {
    if (hasCommitment) {
      return values(productLineItem.commitmentTiersUsageMap).reduce((acc, curr) => {
        return acc + sumBy(curr, 'periodUnits');
      }, 0);
    }
  
    return isNotFixedLineItem ? productLineItem.units : 0;
  }, [hasCommitment, productLineItem, isNotFixedLineItem]);
}